import "./AboutUs3.module.css";
import Header from "@/reusable_sections/Header";
import NuestraHistoria from "./sections/NuestraHistoria";
import MisiNYValores from "./sections/MisiNYValores";
import NuestroEquipo from "./sections/NuestroEquipo";
import Footer from "@/reusable_sections/Footer";
export default function AboutUs3Page() {
  return <div>
      <Header />
      <NuestraHistoria />
      <MisiNYValores />
      <NuestroEquipo />
      <Footer />
    </div>;
}